import * as React from 'react';
const CicatriciECheloidiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M127.76 64.07c0 6.53-1.63 16.47-1.63 21.23 0 19.6 11.43 24.49 11.43 50.62M72.24 64.07c0 6.53 1.63 16.47 1.63 21.23 0 19.6-11.43 24.49-11.43 50.62M100 103.27s-3.13 2.45 0 4.9"
      className="prefix__cls-2"
    />
    <path d="M81.46 118.54s18.07 7.42 37.08 0" className="prefix__cls-1" />
    <path
      d="M88.42 117.88s-1.69 2.83-1.18 5.67M113.36 117.88s-1.69 2.83-1.18 5.67M99.97 117.45s-1.31 4.39-.91 8.78"
      className="prefix__cls-1"
    />
  </svg>
);
export default CicatriciECheloidiIcon;
